export const ifView = (viewName, callback = () => {}) => {
  const predicates = viewName instanceof Array ? viewName : [viewName];
  const currentView = document.documentElement.dataset.view;

  const matches = predicates.some((predicate) => {
    if (predicate instanceof RegExp) {
      return predicate.test(currentView);
    } else if (typeof predicate === "string") {
      return predicate === currentView;
    } else if (typeof predicate === "function") {
      return predicate(currentView);
    }
  });

  if (matches) {
    callback();
    return true;
  }

  return false;
};

export const onViewLoad = (viewName, callback) => {
  if (process.env.RAILS_ENV === "test") {
    window.__viewLoadPending = (window.__viewLoadPending || 0) + 1;
  }

  const runCallback = () => {
    ifView(viewName, callback);
    if (process.env.RAILS_ENV === "test") {
      window.__viewLoadCompleted = (window.__viewLoadCompleted || 0) + 1;
    }
  };

  if (["complete", "interactive"].includes(document.readyState)) {
    runCallback();
  } else {
    document.addEventListener("DOMContentLoaded", runCallback);
  }
};

// Returns a Promise that resolves once all onViewLoad callbacks have completed.
// Used by the test suite to avoid repeated Ruby->browser polling calls.
if (process.env.RAILS_ENV === "test") {
  window.waitOnViewLoad = (timeout = 5000) => {
    return new Promise((resolve, reject) => {
      const pollingInterval = 50;
      const stableZeroDuration = 250;
      const startTime = Date.now();
      let zeroSeenAt = null;

      const poll = () => {
        const pending = window.__viewLoadPending || 0;
        const completed = window.__viewLoadCompleted || 0;
        const elapsed = Date.now() - startTime;

        if (elapsed > timeout) {
          reject(
            new Error(
              `Timeout waiting for JS init (${(elapsed / 1000).toFixed(2)}s): pending=${pending}, completed=${completed}`
            )
          );
          return;
        }

        if (pending > 0 && pending === completed) {
          resolve();
        } else if (pending === 0) {
          if (zeroSeenAt === null) zeroSeenAt = Date.now();
          if (Date.now() - zeroSeenAt > stableZeroDuration) {
            resolve();
          } else {
            setTimeout(poll, pollingInterval);
          }
        } else {
          zeroSeenAt = null;
          setTimeout(poll, pollingInterval);
        }
      };

      poll();
    });
  };
}
